export const remoteLog = (error: Error, attributes = {}) => {
  if (window && window.newrelic) {
    window.newrelic.noticeError(error, attributes)
  }
}
